/**
 * This function adds a click event listener for all the buttons inside the Read More Box widgets within the document.
 * @param callback - The function that will be called when clicking on the Read More or Read Less buttons.
 */
export function toggleReadMoreBoxes(callback: (event: MouseEvent) => void) {
  try {
    const allReadMoreButtons: HTMLElement[] = Array.from(
      document.querySelectorAll('.read-more-toggle-open,.read-more-toggle-close'),
    );
    allReadMoreButtons.forEach((element) => {
      const parent = element.closest('.read-more-box-widget');
      // Add the closed class to the read more boxes that are not open
      if (!parent?.classList.contains('open')) {
        parent?.classList.add('closed');
      }
      element.addEventListener('click', callback);
    });
    return () => {
      allReadMoreButtons.map((element) => element.removeEventListener('click', callback));
    };
  } catch {}
}

/**
 * This function adds toggle functionality to the Read More Box
 * by adding the necessary open or closed classes to the widget.
 * @param event {MouseEvent} - event that triggers the toggle
 */
export function handleReadMoreToggle(event: MouseEvent) {
  const target = event.target as Element;
  const parent = target.closest('.read-more-box-widget');
  if (parent?.classList.contains('open')) {
    parent?.classList.remove('open');
    parent?.classList.add('closed');
  } else if (parent?.classList.contains('closed')) {
    parent?.classList.remove('closed');
    parent?.classList.add('open');
  }
}
